import * as React from 'react'

class Message extends React.Component {
	render() {
		return (
			<div className="ecf-form-donate__item-text-area">
                <h4 className="ecf-form-donate__item-text-area-title section-item-title">
                    <span>
                        Leave a message
                    </span>
                    <span>
                        (Optional)
                    </span>
                </h4>
                <div className="ecf-form-donate__item-text-area-item">
                    <textarea defaultValue="Your message" />
                </div>
            </div>
		)
	}
}

export default Message;